module.exports = __webpack_public_path__ + "Rectangle.b88debd1b62e8c38115a.png";


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/img/Rectangle.png
// module id = ../../../../../src/img/Rectangle.png
// module chunks = main